import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { OnTimeFulfillmentTime, } from "../../ordering";
import { RArray } from "../../collections";
export class PTodayFulfillmentTime {
    constructor(params) {
        this.type = "Today";
        this.restaurant = params.restaurant;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.purchaseOrder = params.purchaseOrder;
        this.label = I18n.t("orders.form.choose_time");
        makeAutoObservable(this);
    }
    get domain() {
        return this.fulfillmentInstructions.fulfillmentTime;
    }
    get isAvailable() {
        return !this.purchaseOrder.isPreorder && !this.hours.isEmpty;
    }
    get isActive() {
        return (this.isAvailable && this.domain !== null && this.domain.type === "OnTime");
    }
    get hours() {
        if (this.restaurant.fulfillmentTimes === null) {
            return RArray.empty();
        }
        return this.restaurant.fulfillmentTimes.mapOptional((item) => item.type === "OnTime" ? item.date.fullHour : null);
    }
    setDefaultValue() {
        const firstAvailableHour = this.hours.find(0);
        if (firstAvailableHour !== null) {
            this.setHour(firstAvailableHour);
        }
    }
    setDate() {
        throw new Error("Today fulfillment time cannot set date");
    }
    setHour(value) {
        const date = RDate.fromTimeString(value, this.restaurant.timezone);
        // TODO: what if time is not valid?
        if (!date.isValid) {
            return;
        }
        this.fulfillmentInstructions.fulfillmentTime = new OnTimeFulfillmentTime({
            date,
        });
    }
}
